type ErrorSummaryProps = { errors: string[] };

export function ErrorSummary({ errors }: ErrorSummaryProps) {
  return (
    <section
      role="alert"
      aria-labelledby="error-summary-title"
      className="rounded-xl border border-red-300 bg-red-50 p-4"
    >
      <h2 id="error-summary-title" className="font-bold">
        Please check the following
      </h2>
      <ul className="mt-2 list-disc pl-5">
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </section>
  );
}

export function LabelledField() {
  return (
    <label className="grid gap-2 font-semibold">
      Reference label
      <input
        className="rounded-lg border border-slate-400 p-2 font-normal"
        aria-describedby="reference-hint"
      />
      <span id="reference-hint" className="text-sm font-normal text-slate-600">
        Use an anonymous reference only.
      </span>
    </label>
  );
}
